import { useEffect, useState } from 'react';
import { Box, Tag, Heading, Flex, Text, Link as ChakraLink, Stack, Avatar } from '@chakra-ui/react';
import Image from 'next/image';
import Link from 'next/link';
import { formatDate } from '@/helpers/formatDate';

interface Props {
  data: any;
}

export default function PostBanner({ data }: Props) {
  const [date, setDate] = useState<String>();

  useEffect(() => {
    setDate(formatDate(data.updatedAt));
  }, [data]);

  return (
    <Box
      as="section"
      width={{ base: "90%", lg: "100%" }}
      height={{ base: '400', md: '558' }}
      margin="0 auto"
      paddingTop={{ base: '0px', lg: '0px' }}
      paddingBottom={{ base: '0px', lg: '80px' }}
      position="relative"
    >
      <Box
        maxWidth="1216px"
        margin="0 auto"
        display="flex"
        alignItems="flex-end"
        justifyContent="flex-end"
        columnGap="32px"
        width="90%"
      >
        <Box display="flex" flexDirection="column" rowGap="16px">
          {data && (
            <Box
              maxWidth="1216px"
              width="100%"
              height="100%"
              left="50%"
              right="0"
              transform="translateX(-50%)"
              overflow="hidden"
              borderRadius="16px"
              position="absolute"
              p={{ base: "16px", lg: "0" }}
            >
              <Image
                fill
                priority
                style={{ objectFit: 'cover' }}
                placeholder="blur"
                blurDataURL={data.mainImage?.data.attributes.url}
                src={data.mainImage?.data.attributes.url}
                alt={data.title}
              />
              <Box
                display="block"
                width="100%"
                height="100%"
                position="absolute"
                top="0"
                left="0"
                bgGradient="linear-gradient(180deg, rgba(45, 55, 72, 0) 27.39%, #2D3748 100%)"
              />
              <Flex
                height="100%"
                justifyContent="flex-end"
                alignItems="flex-start"
                position="relative"
                width="90%"
                pb={{ base: "16px", lg: "56px" }}
                margin=" 0 auto"
                flexDirection="column"
              >
                <ChakraLink
                  as={Link}
                  href={`/blog/categoria/${data.category.data[0].attributes.slug}`} p="0 !important">
                  <Tag
                    bgColor={data.category.data[0].attributes.bgColor}
                    color={data.category.data[0].attributes.color}
                    textTransform="uppercase"
                    mb="24px"
                  >
                    {data.category.data[0].attributes.title}
                  </Tag>
                </ChakraLink>
                <Heading
                  as="h1"
                  width="100%"
                  maxWidth="1000px"
                  color="#FFF"
                  fontSize={{ base: '30px', lg: '48px' }}
                  lineHeight={{ base: "36px", lg: "48px" }}
                  fontWeight="700"
                >
                  {data.title}
                </Heading>
                <Flex margin={{ base: "16px 0", lg: "16px 0 32px 0" }} gap="16px">
                  <Text color="#FFF" fontSize={{ base: "14px", lg: "20px" }} lineHeight={{ base: "20px", lg: "28px" }}>
                    {date}
                  </Text>
                  <Text color="#FFF" fontSize={{ base: "14px", lg: "20px" }} lineHeight={{ base: "20px", lg: "28px" }}>
                    •
                  </Text>
                  <Text color="#FFF" fontSize={{ base: "14px", lg: "20px" }} lineHeight={{ base: "20px", lg: "28px" }}>
                    {data.readingTime} min de leitura
                  </Text>
                </Flex>

                <Stack alignSelf="stretch" direction="row" justify="flex-start" align="center" spacing="16px">
                  <Avatar
                    width="48px"
                    height="48px"
                    name={data.author.data.attributes.name}
                    src={data.author.data.attributes.img?.data.attributes.url}
                  />
                  <Box>
                    <ChakraLink
                      as={Link}
                      href={`/blog/perfil/${data.author.data.attributes.url}`}
                      fontSize="14px"
                      lineHeight="20px"
                      textDecoration="none"
                      w="auto"
                      p="0 !important"
                      _hover={{
                        textDecoration: 'none',
                      }}
                      fontWeight="500"
                      color="#FFF"
                    >
                      {data.author.data.attributes.name}
                    </ChakraLink>
                    <Text lineHeight="16px" color="gray.200" fontWeight="400" fontSize="12px">
                      {data.author.data.attributes.jobTitle}
                    </Text>
                  </Box>
                </Stack>
              </Flex>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
